import { useQueryState } from 'hooks/useQueryState';

import { useQueryGetSingleTemplate } from 'api/queries/getSingleTemplate.query';

import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';

import { Phases } from 'components/Dashboards/Portfolio/phasePerformance/manage/addTemplate/phases/phases';
import classes from 'components/Dashboards/Portfolio/phasePerformance/manage/components/addTemplate.module.scss';

export const AddTemplate = () => {
    const [templateId] = useQueryState('templateId');

    const { data } = useQueryGetSingleTemplate(templateId);

    return (
        <WidgetWithTitle title={'Add & Edit Template'}>
            <div className={classes.contentWrapper}>
                <Phases templateData={data} isEditMode={Boolean(templateId)} />
            </div>
        </WidgetWithTitle>
    );
};
